import React, { useEffect, useState } from 'react';
import { Analytics_AddToCart } from '/Foundation/Common/code/Views/Foundation/Common/AdobeAnalytics/Analytics_AddToCart';
function Cart({ configuration }) {
  const localStorage_dbgCart = 'localStorage_dbgCart';
  const [cartQuantity, setCartQuantity] = useState(0);
  const [products, setProducts] = useState({});
  const [orderListParameters, setOrderListParameters] = useState([]);
  const urlParams = new URLSearchParams(window.location.search);
  const addToCart = (newProducts) => {
    let sprod = { ...window.dbg_products };
    newProducts.forEach((product) => {
      const existingProduct = sprod[product.productId];
      if (existingProduct) {
        existingProduct.quantity += 1;
      } else {
        sprod[product.productId] = product;
      }
    });
    setProducts(sprod);
  };

  const setupButtonEvents = () => {
    //override modal go to cart link
    let modalGoToCartBtn = document.querySelectorAll('.modal-dialog .btn.thule-btn-shop.btn-goto-cart')[0];
    if (modalGoToCartBtn) modalGoToCartBtn.setAttribute('href', configuration.DealerImportCartLink);

    if (!configuration.ShowAddToCartButton) return;

    const addToCartButtons = document.querySelectorAll('.product-add-to-cart .thule-btn-shop');
    addToCartButtons?.forEach((button) => {
      button.classList.add('dbg_cart_btn');
      button.addEventListener('click', (event) => {
        const wrapper = button.closest('.product-add-to-cart');
        const solution = wrapper.querySelector('input.product-ids-for-solution').value;
        const sku = wrapper.querySelector('input.atc-product-sku').value;
        const newProducts = [];
        if (solution) {
          const ids = solution.split(',');
          for (let i = 0; i < ids.length; i++) {
            newProducts.push({
              productId: ids[i],
              quantity: 1,
            });
          }
        } else {
          newProducts.push({
            productId: sku,
            quantity: 1,
          });
        }
        addToCart(newProducts);

        document
          .querySelectorAll('.modal-dialog .btn.thule-btn-shop.btn-goto-cart')[0]
          ?.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector('#dbg_gotocart')?.click();
          });
      });
    });
    Analytics_AddToCart?.ApplyAddToCartButtonEvent();
  };

  const saveCartToLocalStorage = (products) => {
    const jsonStr = products ? JSON.stringify(products) : null;
    if (jsonStr) {
      localStorage.setItem(localStorage_dbgCart, jsonStr);
    }
  };

  const getCartFromLocalStorage = () => {
    var productsJson = localStorage.getItem(localStorage_dbgCart);
    if (productsJson) return productsJson ? JSON.parse(productsJson) : null;
  };

  useEffect(() => {
    setupButtonEvents();
    var savedProducts = getCartFromLocalStorage();
    if (savedProducts) setProducts(savedProducts);
  }, []);

  useEffect(() => {
    window.dbg_products = products;
    saveCartToLocalStorage(products);
    let totalQuantity = 0;
    for (const key in products) {
      totalQuantity += products[key].quantity;
    }
    setCartQuantity(totalQuantity);

    const keys = Object.keys(products);
    let orderList = '';
    if (configuration.UseAsinInCart) {
      getAsin(keys, (mappings) => {
        keys.forEach((productKey) => {
          if (orderList) orderList += ',';
          const product = products[productKey];
          orderList += mappings[product.productId] + '_' + product.quantity;
        });
        setOrderListParameters(orderList);
      });
    } else {
      keys.forEach((productKey) => {
        if (orderList) orderList += ',';
        const product = products[productKey];
        orderList += product.productId + '_' + product.quantity;
      });
      setOrderListParameters(orderList);
    }
  }, [products]);

  const getAsin = (productIds, callback) => {
    fetch('/api/sitecore/product/GetAsinIdsFromProductIds', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(productIds),
    })
      .then((response) => response.json())
      .then((data) => {
        callback(data);
      })
      .catch((error) => {});
  };

  const dosubmit = (e) => {
    if (cartQuantity === 0) e.preventDefault();
    localStorage.removeItem(localStorage_dbgCart);
  };

  const cartButtonContent = () => {
    return (
      <>
        <i className={'fas fa-shopping-cart ' + (cartQuantity == 0 ? 'empty' : '')} />
        {cartQuantity > 0 && <span className="badge">{cartQuantity}</span>}
        <span className="sr-only">Go to cart</span>
      </>
    );
  };

  return (
    <div className="dbg_cart px-2">
      {!configuration.SendViaPOST && (
        <a
          id="dbg_gotocart"
          onClick={dosubmit}
          href={configuration.DealerImportCartLink + 'order_list=' + orderListParameters}
        >
          {cartButtonContent()}
        </a>
      )}

      {configuration.SendViaPOST && (
        <form onSubmit={(e) => dosubmit(e)} method="post" action={configuration.DealerImportCartLink}>
          <input type="hidden" name="dealer" value={urlParams.get('dealerid')} />
          <input type="hidden" name="order_list" value={orderListParameters} />
          <button id="dbg_gotocart" className="p-0" type="submit">
            {cartButtonContent()}
          </button>
        </form>
      )}
    </div>
  );
}

export default Cart;
